module.exports = __webpack_public_path__ + "static/media/vertical-farming.489a57bf.jpg";